import React from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import ImageComponent from '@components/common/ImageComponent/ImageComponent';

interface BannerProps {
  bannerHeading: string;
  ctaActionUrl?: string;
}

const Banner = (props: BannerProps) => {
  const { bannerHeading } = props;
  const assetUrl = process.env.NEXT_PUBLIC_SHARED_CDN_URL || '';

  return (
    <section
      className={ivclass(
        'iv-h-[56px] sm:iv-h-[81px] sm:iv-w-full iv-bg-[#E7EFFE]',
      )}
    >
      <a
        href="https://legacy.kizoa.com"
        rel="noopener noreferrer"
        className={ivclass(
          'iv-block xl:iv-container iv-text-center xl:iv-mx-auto iv-mt-10',
          'md:iv-px-10 sm:iv-px-10 iv-w-full iv-h-full',
        )}
      >
        <div
          className={ivclass(
            'iv-grid iv-grid-cols-12 iv-h-full lg:iv-mx-40 md:iv-mx-25',
            'sm:iv-mx-20',
          )}
        >
          <div
            className={ivclass(
              'xl:iv-col-span-10 iv-col-span-12 xl:iv-col-start-2 iv-h-full',
              'iv-flex iv-items-center sm:iv-justify-between',
            )}
          >
            <div
              className={ivclass(
                'iv-flex iv-justify-center iv-items-center iv-h-full',
                'sm:iv-flex-col  iv-w-full',
                'sm:iv-justify-center',
                'iv-text-center sm:iv-text-left sm:iv-text-body-xl iv-font-semibold iv-text-body-3xl iv-text-black-85',
                'iv-inline-block',
              )}
            >
              <div>
                <span>{bannerHeading}</span>
                &nbsp;
                <span>
                  <ImageComponent
                    elementype="native"
                    src={`${assetUrl}/header-icons/arrow-top-right-dark.svg`}
                    alt="arrow"
                    loading="lazy"
                    width="15"
                    height="15"
                    className={ivclass('iv-inline-block')}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </a>
    </section>
  );
};

export default Banner;
